export function similarity(expected: string, heard: string, ignoredWords: string[] = ["um", "uh", "er"]): number {
  const ignored = new Set(ignoredWords.map((word) => word.toLowerCase()));
  const words = (value: string) => new Set(value.toLowerCase().replace(/[^\p{L}\p{N}\s]/gu, "").split(/\s+/).filter((word) => word && !ignored.has(word)));
  const expectedWords = words(expected);
  const heardWords = words(heard);
  if (!expectedWords.size) return 1;
  return [...expectedWords].filter((word) => heardWords.has(word)).length / expectedWords.size;
}
